import { motion } from "framer-motion";
import { Phone, FileText, ChevronDown, Star } from "lucide-react";
import { Button } from "@/components/ui/button";

const HeroSection = () => {
  return (
    <section
      className="relative h-[85vh] min-h-[550px] flex items-end overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://customer-assets.emergentagent.com/job_21ac811b-a248-4ccc-b1af-d39168c4c5ba/artifacts/a4hqk1g2_19.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
      </div>

      {/* Content - positioned at bottom left */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 lg:px-12 w-full pb-16 md:pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-2xl"
        >
          {/* Google Review Badge */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.3, duration: 0.6 }}
            className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-5"
          >
            <div className="flex items-center gap-0.5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" />
              ))}
            </div>
            <span className="text-white/90 text-sm font-medium">5 · 9+ Reviews</span>
          </motion.div>

          {/* Headline */}
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
            Trees & Landscaping in{" "}
            <span className="text-[#90EE90]">Northumberland</span>
          </h1>

          {/* Subheading */}
          <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-lg">
            Your local landscaping specialists — driveways, patios, garden design, grounds maintenance and tree surgery. Serving Northumberland.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <Button
              asChild
              size="lg"
              className="bg-[#1A4D2E] hover:bg-[#143D24] text-white font-bold py-5 px-8 rounded-full shadow-lg transform hover:-translate-y-0.5 transition-all text-base"
              data-testid="hero-quote-btn"
            >
              <a href="#contact" className="flex items-center gap-2">
                <Phone className="w-5 h-5" />
                Book Free Quote
              </a>
            </Button>
            <Button
              asChild
              size="lg"
              variant="outline"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#1A4D2E] font-bold py-5 px-8 rounded-full transition-all text-base"
              data-testid="hero-work-btn"
            >
              <a href="#gallery" className="flex items-center gap-2">
                <FileText className="w-5 h-5" />
                View Our Work
              </a>
            </Button>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.2, duration: 0.6, repeat: Infinity, repeatType: "reverse" }}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 text-white/60"
      >
        <ChevronDown className="w-7 h-7" />
      </motion.div>
    </section>
  );
};

export default HeroSection;
